import { keepPreviousData, useQuery } from "@tanstack/react-query";
import useApi from "../../../shared/hooks/useApi";
import { queryKeys } from "../../../shared/query-keys";
import { CaregiverId } from "../../../shared/schema/schema";

export function useSearchCaregiversQuery(params: { term: string }) {
  const { api } = useApi();

  return useQuery({
    queryKey: queryKeys.caregiver.search(params.term),
    queryFn: () =>
      api.get("./search/caregivers", {
        query: { q: params.term, limit: 10 },
      }),
    enabled: params.term !== "",
    // The endpoint returns ids unwrapped; brand them here so every caller keeps
    // working with CaregiverId rather than a bare number.
    select: (data) => data.items.map((item) => ({ ...item, id: item.id as CaregiverId })),
    placeholderData: params.term !== "" ? keepPreviousData : undefined,
  });
}
